import {Component, OnInit, Input, OnChanges, SimpleChanges, EventEmitter, Output, ChangeDetectionStrategy} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import { firstValueFrom } from 'rxjs';

const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');

@Component({
  selector: 'embed-html-doc',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './embed-html-doc.component.html'
})
export class EmbedHtmlDocComponent implements OnInit, OnChanges {
  @Input() path: string = "";
  @Output() onMarkupLoaded = new EventEmitter<boolean>();

  markup?: string;
  loaded: boolean = false;

  constructor(public route: ActivatedRoute, public http: HttpClient) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    this.markup = undefined;
    this.fetchContent(changes.path.currentValue);
  }

  async fetchContent(path: string) {
    this.markup = undefined;
    this.loaded = false;

    this.onMarkupLoaded.emit(false);

    await firstValueFrom(this.http.get(path, {headers, responseType: 'text'}))
      .then(markup => {
        const basePath = location.pathname + location.search;
        markup = markup.replace(/href=("|')#(.*)("|')/gi, `href="${basePath}#$2"`);
        markup = markup.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');

        this.loaded = true;
        this.markup = markup;
        this.onMarkupLoaded.emit(true);
      },
      () => {
        this.loaded = true;
    });
  }
}
